'use strict';
import axios from 'axios';
import getHeader from '../config/header';
import passwordSecure from '../services/passwordSecure';
import getTimeZone from '../services/getTimeZone';

const API_URL = process.env.VUE_APP_API_URL || "http://localhost:3001/api";

const Admin = {

    // Invite an curator via email
    async sendCuratorInvite(info, museum) {
        try {

            if (!info.firstName || !info.lastName || !info.jobTitle || !info.email || !info.phoneNumber || !info.displayName || !museum) {
                return { error: 'Please make sure all mandatory fields are filled' };
            }

            if (info.isPlatinum == true && (!info.artworkLimit || !info.pushNotificationLimit || !info.pushNotificationRecipientLimit || !info.catalogUserLimit)) {
                return { error: 'Please make sure all mandatory fields are filled' };
            }

            if (info.isPlatinum == true && (isNaN(info.artworkLimit) || isNaN(info.pushNotificationLimit) || isNaN(info.pushNotificationRecipientLimit) || isNaN(info.catalogUserLimit))) {
                return { error: 'Please make sure all mandatory fields are filled' };
            }

            const header = await getHeader();
            const timeZone = getTimeZone();

            let response = await axios.post(API_URL + '/user/registerCurator', {
                name: info.firstName + ' ' + info.lastName,
                email: info.email,
                displayName: info.displayName,
                jobTitle: info.jobTitle,
                museumIds: [ museum ],
                isPlatinum: info.isPlatinum,
                phoneNumber: info.phoneNumber,
                artworkLimit: parseInt(info.artworkLimit),
                pushNotificationLimit: parseInt(info.pushNotificationLimit),
                pushNotificationRecipientLimit: parseInt(info.pushNotificationRecipientLimit),
                catalogUserLimit: parseInt(info.catalogUserLimit),
                timezone: timeZone
            }, header);

			return response.data;

		} catch(error) {
            return false;
		}
    },

    // Create a curator
    async createCurator(name, email, displayName, jobTitle, phoneNumber, password, museumIDs) {
		try {
            if (!name || !email || !displayName || !jobTitle || !phoneNumber || !password || !museumIDs) {
                return { error: "A mandatory field is missing"};
            }

            // Validate the password
            if (passwordSecure(password) === false) {
                return { 
                    error: "Password must be at least ten characters long, contain at least one uppercase letter, one number and two special characters",
                    passwordError: true
                }
            }

            const timeZone = getTimeZone();

            let response = await axios.post(API_URL + '/user/admin', {
                name: name, 
                email: email,
                displayName: displayName,
                jobTitle: jobTitle,
                phoneNumber: phoneNumber,
                password: password,
                museumIds: museumIDs,
                timezone: timeZone
            });

            if (response.data.firebase_uid) {
                return response.data.firebase_uid;
            } else {
                return false;
            }

		} catch(error) {
            return { error: error.response.data.message || error.response.data.Error };
		}
    },
    
    // Create a subscription
    async createSubscription(firebaseID, planID) {
		try {
            if (!planID || !firebaseID) {
                return { error: "A mandatory field is missing"};
            }

            let response = await axios.post(API_URL + '/createUserSubscription/' + firebaseID, {
                planId: planID
            });

            if (!response.data.user_id) {
                return false;
            }
            
            return true;

		} catch(error) {
            return { error: error.response.data.message || error.response.data.Error};
		}
	},

    // Create a super-admin
	async createSuperAdmin(superAdminInfo) {
		try {

            if (!superAdminInfo.firstName || !superAdminInfo.lastName || !superAdminInfo.email || !superAdminInfo.password) {
                return { error: "A mandatory field is missing" };
            }

            // Validate the password
            if (passwordSecure(superAdminInfo.password) === false) {
                return { 
                    error: "Password must be at least ten characters long, contain at least one uppercase letter, one number and two special characters",
                    passwordError: true
                }
            }

            const header = await getHeader();
            const timeZone = getTimeZone();

            let response = await axios.post(API_URL + '/user/superAdmin', {
                name: superAdminInfo.firstName + ' ' + superAdminInfo.lastName,
                email: superAdminInfo.email,
                displayName: superAdminInfo.firstName,
                password: superAdminInfo.password,
                timezone: timeZone
            }, header);
            
            if (response.data.firebase_uid) {
                return true;
            }

            return false;

		} catch(error) {
            return { error: error.response.data.Error || error.response.data.message };
		}
    },

    async getCurators() {
        try {
            const header = await getHeader();

            let response = await axios.get(API_URL + '/user/curators', header);

            return response.data;
            
        } catch(error) {
            return false;
        }
    },

    async getCuratorCount() {
        let curators = await this.getCurators();
        return curators !== false ? curators.length : 0;
    },

    async getAdmins() {
        try {
            const header = await getHeader();

            let response = await axios.get(API_URL + '/user/admins', header);

            return response.data;
            
        } catch(error) {
            return false;
        }
    }
    
}

export default Admin;
